
export class PropertyContactType {
    constructor(
        public isPrimary: boolean = true,
        public phone: string = '',
        public contactType: string = 'head_office',
    ) {
    }
}



// WEBPACK FOOTER //
// /app/src/app/types/models/PropertyContactType.ts